<script setup>

import down from "@/assets/img/down.png";
import titlePicture from "@/assets/img/news_1.jpg";
import {onMounted, ref} from "vue";
import {getImagePath, getNewsData} from "@/utils/utils";
import {useRoute} from 'vue-router';

let newsDetail = ref({})
onMounted(() => {
  const route = useRoute();
  const id = parseInt(route.params.id, 10);
  let newsDataList = getNewsData(false)
  console.log(newsDataList)
  for (let count = 0; count < newsDataList.length; count++) {
    if (newsDataList[count].id === id) {
      newsDetail.value = newsDataList[count]
      newsDetail.value.img_url = getImagePath(newsDetail.value.img_url, "news")
      break
    }
  }

})
</script>

<template>
  <div>
    <div style="background-color: rgb(243.9, 244.2, 244.8);">
      <div class="first-picture-font">
        <div class="gothamBold">
          NEWS Detail
        </div>
        <div class="puHuiTi-Medium" style="font-size: 1.5rem;font-weight: lighter">
          新闻详情
        </div>

        <el-image
            style="height: 2.5rem;padding-top: 0.8rem;  animation: smooth-bounce 2s infinite; /* 匀速跳动动画 */"
            :src="down" fit="cover"/>
      </div>
      <el-image
          style="width: 100%;height: 23rem"
          :src="titlePicture"
          fit="cover"
      />

    </div>

    <el-row>
      <el-col class="gothamBold" :offset="3"
              style="text-align: left;margin-top: 3rem;margin-bottom: 2rem;font-weight: bold">
        <span class="profile-title">NEWS</span>
        <br>
        <span class="company_font_blue profile-title">DETAIL</span>
        <br>
        <div class="puHuiTi-regular" style="font-size: 2rem;margin-top: 0.5rem;font-weight: lighter">
          新闻详情
        </div>

      </el-col>
      <el-col :offset="3" :span="18" style="margin-bottom: 6rem">
        <div class="puHuiTi-Medium detail-title">{{ newsDetail.title }}</div>
        <el-image style="width: 100%;margin-top: 3rem;margin-bottom: 3rem;height: 25rem"
                  :src="newsDetail.img_url" fit="cover"/>
        <div class="puHuiTi-regular" style="font-size: 1.2rem;white-space: pre-wrap;line-height: 1.5">
          {{ newsDetail.content }}
        </div>
      </el-col>
    </el-row>

  </div>
</template>

<style scoped>
.detail-title {
  font-size: 2rem;
}
</style>